import React from "react"
import {
  addressItemAddress,
  addressItemCompAddress,
  addressItemVoie,
  addressItemName,
  addressItemTitle,
  addressItemContacts,
  addressItemTel,
  addressItemMail,
  addressMore,
} from "../carnet-adresse.module.scss"
import { AddressTitle, StyledLink } from "./address-content-styled"
import PropTypes from "prop-types"
import TransitionFade from "../../../transition-fade"
import Obfuscate from "react-obfuscate"

const AddressContent = ({ address }) => (
  <>
    <TransitionFade className={addressItemName} link={address.path.alias}>
      <AddressTitle className={addressItemTitle}>{address.title}</AddressTitle>
      <div className={addressItemAddress}>
        <div className={addressItemVoie}>
          {address.field_adresse.address_line1}
        </div>
        {address.field_adresse.address_line2 && (
          <div className={addressItemCompAddress}>
            {address.field_adresse.address_line2}
          </div>
        )}
        <div>
          {address.field_adresse.postal_code} {address.field_adresse.locality}
        </div>
      </div>
    </TransitionFade>
    <div className={addressItemContacts}>
      {address.field_mail && (
        <Obfuscate email={address.field_mail} className={addressItemMail} />
      )}
      {address.field_telephone && (
        <Obfuscate tel={address.field_telephone} className={addressItemTel} />
      )}
    </div>
    <StyledLink className={addressMore} link={address.path.alias}>
      Plus d&apos;infos
    </StyledLink>
  </>
)

AddressContent.propTypes = {
  address: PropTypes.object.isRequired,
}

export default AddressContent
